export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref8245.a99c1733.jpg";